// Stable PCC action types, in the report's column order (shared with the ADT report and the KPI pages).
export { PCC_ACTION_TYPES } from '../../constants/pcc-action-types';
export type { PccActionType } from '../../constants/pcc-action-types';

export interface CensusActionLabel {
  _id: string;
  regionId: number;
  actionTypes: string[];
  name: string;
  displayOrder?: number;
}

export interface CensusCodeAssignment {
  shortDesc: string;
  longDesc: string;
  pccActionType: string | null;
  labelIds: string[];      // multiple labels per code; empty = excluded from the report
  labelNames: string[];    // names aligned with labelIds (same order)
}

// Backend returns codes grouped by their pccActionType. Codes PCC didn't classify
// (pccActionType=null) are excluded — they don't appear in the report.
export type CensusCodesByActionType = Record<string, CensusCodeAssignment[]>;
